import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import yaml from "js-yaml";
import { yamlConfigState } from "features/optimization/state/yamlConfigAtoms";
import { CustomButton } from "shared/ui/CustomButton";
import { CustomTextField } from "shared/ui/CustomTextField";

interface Props {
  open: boolean;
  onClose: () => void;
  fileName: string;
}

const isParsable = (
  stage: string
): any => {
  try {
    yaml.load(stage);
    return stage;
  } catch (error) {
    // パースエラー
    alert("入力されたYAMLの形式が正しくありません。");
    return null;
  }
};

export const YamlEditor: React.FC<Props> = ({
  open,
  onClose,
  fileName
}) => {
  const [yamlConfig, setYamlConfig] = useRecoilState(yamlConfigState);
  const [stage, setStage] = useState<string>(yamlConfig);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setStage(e.target.value);
  };

  const handleSave = () => {
    if (isParsable(stage) !== null) {
      setYamlConfig(stage);
      onClose();
    }
  };

  useEffect(() => {
    setStage(yamlConfig);
  }, [yamlConfig, open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        '& .MuiDialog-paper': {
          width: '80%',  // 幅を80%に設定
          maxWidth: '50%',  // 最大幅を60%に制限
          backgroundColor: 'gray',  // 背景色を変更
        },
      }}
    >
      <DialogTitle>
        Editing {fileName}
      </DialogTitle>
      <DialogContent>
        <CustomTextField
          multiline
          rows={20}
          variant="outlined"
          fullWidth
          value={stage}
          onChange={handleInputChange}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        <CustomButton
          size="small"
          onClick={onClose}
          sx={{ fontSize: '10px', width: '20%' }}
        >Cancel
        </CustomButton>
        <CustomButton
          size="small"
          onClick={handleSave}
          color="primary"
          sx={{ fontSize: '10px', width: '20%' }}
        >
          Save
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
}
